import React from 'react'

const Flashsale = () => {
  return (
    <div>Flashsale</div>
  )
}

export default Flashsale